import { useDatabase } from '../composables/database'
import { Expense, Expenses } from '../types/expenses'

type ExpensesModelReturn = {
  /**Return all expenses on device */
  getAll: () => Promise<Expenses>
  /**Writes expense to device */
  writeExpenses: (data: Expenses) => Promise<void>
  /**Clears expenses from device */
  clearExpenses: () => Promise<void>
}
export const ExpensesModel = (): ExpensesModelReturn => {
  const { run, query } = useDatabase()

  const getAll = async () => {
    const sql = `
        SELECT * FROM expenses ORDER BY id DESC;
        `
    return await query(sql)
      .catch((error) => console.log(`Error grabbing all expenses: ${error}`))
      .then((expenses) => {
        if (expenses && expenses.length) {
          return JSON.parse(expenses[0]['expense_data']).map((expense: Expense) => {
            return { ...expense, date: new Date(expense.date) }
          })
        } else {
          return []
        }
      })
  }

  const writeExpenses = async (data: Expenses) => {
    const sql = `
        INSERT OR REPLACE INTO expenses ('id', 'expense_data')
        VALUES ((SELECT id FROM expenses WHERE id = 1), ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) =>
      console.log(`Error writing expense to DB: ${error}`)
    )
  }

  const clearExpenses = async () => {
    const sql = 'DELETE FROM expenses'
    await run(sql, []).catch((error) => console.log(`Error deleting expenses: ${error}`))
  }
  return {
    getAll,
    writeExpenses,
    clearExpenses,
  }
}
